import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VLayout,{attrs:{"column":"","justify-center":"","fill-height":""}},[_c(VContainer,{staticClass:"text-center"},[_c(VProgressCircular,{staticClass:"pa-2",attrs:{"size":20,"color":"primary","indeterminate":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }